import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { DynamicDocumentInfoService } from 'src/app/shared/services/dynamic-document-info.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';

const COLLECTION_NAME = 'dynamic_notification_entity';

export type Notification = {
    id: string;
    isUnread: boolean;
    message: string;
    createdAt?: number;
    obj?: any;
};

@Injectable({ providedIn: 'root' })
export class NotificationRepository {
    public unreadMsgCount$ = new BehaviorSubject<number>(0);

    private readStatusDocumentInfoId?: string;

    constructor(
        private dynamicDocumentService: DynamicDocumentService,
        private dynamicDocumentInfoService: DynamicDocumentInfoService,
        private datePipe: DatePipe
    ) {}
    getMyNotifications(): Observable<{
        content: any;
        meta: { totalPages: number; pageSize: number; totalItems: number };
    }> {
        return this.dynamicDocumentService
            .find(
                {
                    collectionName: COLLECTION_NAME,
                    filters: [
                        {
                            fieldName: 'linkToNaturalPersons',
                            conditions: [
                                {
                                    type: 'EQUALS',
                                    value: localStorage.getItem('surname'),
                                }
                            ],
                        },
                    ],
                    page: 1,
                    pageSize: 100,
                    sorts: {
                        updatingDate: 'DESC',
                    },
                },
                true,
                false
            )
            .pipe(
                map((res) => {
                    const allNotfications = res?.content?.map((notification: any) =>
                        this.convertNotification(notification)
                    );

                    this.unreadMsgCount$.next(
                        allNotfications?.reduce(
                            (acc: number, curr: Notification) => (curr.isUnread ? acc + 1 : acc),
                            0
                        )
                    );

                    return {
                        content: allNotfications,
                        meta: {
                            pageSize: res?.size,
                            totalPages: res?.totalPages,
                            totalItems: res?.totalElements,
                        },
                    };
                })
            );
    }

    requestCountUnreadNotifications(): void {
        this.dynamicDocumentService
            .find(
                {
                    collectionName: COLLECTION_NAME,
                    filters: [
                        {
                            fieldName: 'Statut',
                            conditions: [
                                {
                                    type: 'EQUALS',
                                    value: 'NON_LU',
                                },
                            ],
                        },
                        {
                            fieldName: 'linkToNaturalPersons',
                            conditions: [
                                {
                                    type: 'EQUALS',
                                    value: localStorage.getItem('surname'),
                                }
                            ],
                        },
                    ],
                    page: 1,
                    pageSize: 1000,
                },
                true,
                false
            )
            .pipe(
                map((res) => {
                    this.unreadMsgCount$.next(res?.totalElements);
                })
            )
            .subscribe();
    }

    async markAsRead(notifications: Notification[]) {
        if (!this.readStatusDocumentInfoId) {
            const statuses: any = await this.dynamicDocumentInfoService
                .findById('dynamic_notification_entity/Statut');
            this.readStatusDocumentInfoId = statuses?.filter(
                (status: any) => status.valeur === 'LU'
            )[0].id;
        }

        notifications.forEach((notification) => {
            notification.obj.Statut = [this.readStatusDocumentInfoId];
            notification.obj.creationDate = this.datePipe.transform(
                notification.obj.creationDate,
                "yyyy-MM-dd'T'HH:mm:ss"
            );
            notification.obj.updatingDate = this.datePipe.transform(
                Date.now(),
                "yyyy-MM-dd'T'00:00:00"
            );
            this.dynamicDocumentService
                .saveDocument(COLLECTION_NAME, notification.obj, true)
                .subscribe(() => {
                    const unreadMsgCount = this.unreadMsgCount$.getValue() - 1;
                    this.unreadMsgCount$.next(unreadMsgCount < 0 ? 0 : unreadMsgCount);
                });
        });

        // this.dynamicDocumentService.saveDocument(
        //     COLLECTION_NAME,
        //     {
        //         documentId: notifications.map((notification) => notification.id),
        //         document: {
        //             Statut: {
        //                 value: 'LU',
        //             },
        //         },
        //     },
        //     true
        // ).subscribe();
    }

    // --------
    convertNotification(data: any): Notification {
        return {
            id: data?.id,
            isUnread: data?.Statut?.value === 'NON_LU',
            message: data?.message?.fr_FR,
            createdAt: data?.creationDate,
            obj: data,
        };
    }
}
